import { IconVariant } from '@/components/icons/types';
import { formatDate } from '@/helpers/dateTs';
import { _t } from '@/locale';
import { DealSearchItem } from './types/dealSearch';

const baseTranslationKey = 'features.deals.constants' as const;

type DealCondition = {
  icon: IconVariant;
  label: string;
  value: string;
};

const VALID_DATES = (deal: DealSearchItem): DealCondition => ({
  icon: 'calendar-events-alt',
  label: _t(`${baseTranslationKey}.DEAL_CONDITION.VALID_DATES.label`),
  value: `${formatDate(deal.startDate)} - ${formatDate(deal.endDate)}`,
});

const TARGET_GROUP = (deal: DealSearchItem): DealCondition => {
  const targetGroupKey =
    deal.targetGroup === 'all' ? 'ALL' : deal.targetGroup === 'newCustomers' ? 'NEW_CUSTOMERS' : 'EXISTING_CUSTOMERS';
  return {
    icon: 'user-location',
    label: _t(`${baseTranslationKey}.DEAL_CONDITION.TARGET_GROUP.label`),
    value: _t(`${baseTranslationKey}.DEAL_CONDITION.TARGET_GROUP.value.${targetGroupKey}`),
  };
};

const MAX_PURCHASES = (deal: DealSearchItem): DealCondition => ({
  icon: 'wallet',
  label: _t(`${baseTranslationKey}.DEAL_CONDITION.MAX_PURCHASES.label`),
  value: _t(`${baseTranslationKey}.DEAL_CONDITION.MAX_PURCHASES.value`, { count: deal.maxCountCustomer }),
});

const BOOKING_MARGIN = (deal: DealSearchItem): DealCondition => {
  // @TODO - check booking margin from services
  return {
    icon: 'calendar-note',
    label: _t(`${baseTranslationKey}.DEAL_CONDITION.BOOKING_MARGIN.label`),
    value: _t(`${baseTranslationKey}.DEAL_CONDITION.BOOKING_MARGIN.value`, { minutes: 0 }),
  };
};

export const DEAL_CONDITION = {
  VALID_DATES,
  BOOKING_MARGIN,
  TARGET_GROUP,
  MAX_PURCHASES,
};
